import React from 'react';
import { WorkplacePatientStatus } from '../../../../graphql/graphql';
import EArchivePatientsListWrapper from '../EArchivePatientsListWrapper/EArchivePatientsListWrapper';

const EArchiveRegisteredPatientsList = () => {
	const defaultFilter = {
		status: WorkplacePatientStatus.RegisteredToCapitation,
	};
	const excludeFilterFields = { status: true };

	return (
		<EArchivePatientsListWrapper
			defaultFilter={defaultFilter}
			excludeFilterFields={excludeFilterFields}
		/>
	);
};

export default EArchiveRegisteredPatientsList;
